import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

const CustomScrollbar = ({ style,  children }) => {
  return (
    <PerfectScrollbar style={style} >
      {children}
    </PerfectScrollbar>
  );
};

export default CustomScrollbar;
